<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div id="id_select_campaign_lbl" [fxFlex]="labelFlex">
    {{ textLabel | translate }}
  </div>

  <div [fxFlex]="formWrapperFlex">
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #campaignInput
          formControlName="campaign" 
          [matAutocomplete]="campaignAC" 
          (focus)="!campaignAC.isOpen && getInitialValues('campaign')" 
          >

        <mat-icon 
          id="id_select_campaign_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="campaignInput.blur(); clearForm($event)"
          *ngIf="campaignInput.value && !isDisabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!campaignInput.value"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_campaign_dropdown"
          [displayWith]="displayFn" 
          #campaignAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); campaignInput.blur()"
          (opened)="autocompleteScroll('campaign','campaignACRef','campaignACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.campaign && listData?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_campaign_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code + ' - ' + data.description"
            >
            {{ data.code }} - {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.campaign" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('campaign').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: currentStep} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>